import React from 'react'
import {useSelector} from 'react-redux'
import PropTypes from 'prop-types'
import {getActiveResidents} from '../Utils/residentUtils'
import {getCombinedActiveResidents, selectCombinedBuildingsLookup} from '../reducers/selectors'
import PrefixComplete from './PrefixComplete'
import useResidentLookup from './hooks/useResidentLookup'
import useCombinedResidentLookup from './hooks/useCombinedResidentLookup'

function residentToString(resident, getFutureLabel) {
  if (!resident) {
    return ''
  }

  let retVal = resident.displayName + ', Unit ' + resident.occupancy.unit.number
  if (resident.occupancy.status === 'Future') {
    retVal += ` (${getFutureLabel(resident)})`
  }

  return retVal
}

function SearchResident(props) {
  // const activeBuilding = useSelector(state => state.Buildings.buildingsLookup[state.Buildings.activeBuildingId])
  // const hasOnboarding = activeBuilding && !!activeBuilding.onboardingSchema
  const activeResidents = useSelector(getActiveResidents)
  const combinedResidents = useSelector(getCombinedActiveResidents)
  const residents = props.includeSisterBuildings ? combinedResidents : activeResidents
  const {getResident: getActiveResident} = useResidentLookup()
  const {getResident: getCombinedResident} = useCombinedResidentLookup()
  const getResident = props.includeSisterBuildings ? getCombinedResident : getActiveResident

  const combinedBuildingsLookup = useSelector(selectCombinedBuildingsLookup)
  const activeBuildingsLookup = useSelector(state => state.Buildings.buildingsLookup)
  const buildingsLookup = props.includeSisterBuildings ? combinedBuildingsLookup : activeBuildingsLookup

  function getFutureLabel(resident) {
    const building = buildingsLookup[resident.occupancy.unit.unitBuildingId]
    return building && building.onboardingSchema ? 'Onboarding' : 'Future'
  }

  const residentValue =
    typeof props.value === 'string'
      ? getResident(props.value)
      : props.value && typeof props.value === 'object'
      ? getResident(props.value.id)
      : null

  return (
    <PrefixComplete
      options={residents}
      getOptionLabel={r => residentToString(r, getFutureLabel)}
      value={residentValue}
      onChange={props.onSelectResident}
      isRequired={props.isRequired}
      isDisabled={props.disabled}
      label={props.labelText || props.labelText === '' ? props.labelText : 'Tenant and unit'}
      error={props.error}
      textFieldStyle={props.textFieldStyle}
      placeholder={props.placeholderText}
    />
  )
}

SearchResident.propTypes = {
  onSelectResident: PropTypes.func.isRequired, // returns a RichResidentObject
  disabled: PropTypes.bool,
  value: PropTypes.any, // could be a resident object OR just a residentID
  isRequired: PropTypes.bool,
  labelText: PropTypes.string,
  textFieldStyle: PropTypes.any,
  error: PropTypes.bool,
  placeholderText: PropTypes.string,
  includeSisterBuildings: PropTypes.bool, // when true, includes residents from sister buildings (for amenities/events)
}

export default SearchResident
